import React from 'react';
import Typography from '@mui/material/Typography';
import useKeepitalRoutes from '../_hook/useKeepitalRoutes';
import { IEmailContactSubSchema } from '../../../graphql/type/subSchema/emailContact';
import { IUserWorkProfileSubSchema } from '../../../graphql/type/subSchema/userWorkProfile';

interface IProps {
  user: {
    _id: string;
    emails: IEmailContactSubSchema[];
    profile?: {
      works?: IUserWorkProfileSubSchema[];
    };
  };
  typography?: boolean;
  workProfileCompanyId?: string;
}

export default function SchemaUserEmail(props: IProps) {
  const { user, typography, workProfileCompanyId } = props;

  let email: IEmailContactSubSchema | null = null;

  if (workProfileCompanyId) {
    const workProfiles =
      user.profile && user.profile.works ? user.profile.works : [];

    const workProfile = workProfiles.find(
      (work) => work.id === workProfileCompanyId
    );

    if (workProfile) {
      const workProfileEmails =
        workProfile.contact && workProfile.contact.emails
          ? workProfile.contact.emails
          : [];
      const workProfileEmail = workProfileEmails.find(
        (tempEmail) =>
          tempEmail.primary && tempEmail.status && tempEmail.verified
      );
      email = workProfileEmail || workProfileEmails[0];
    }
  } else {
    const userEmails = user.emails || [];

    if (userEmails.length) {
      const userEmail = userEmails.find(
        (tempEmail) => tempEmail.primary && tempEmail.status
      );
      email = userEmail || userEmails[0];
    }
  }

  const emailAddress = email ? email.address : '-';

  if (typography) {
    return (
      <Typography
        variant="body2"
        display="inline"
        component="a"
        color="primary"
        style={{ textDecoration: 'none' }}
        href={`mailto:${emailAddress}`}
      >
        {emailAddress}
      </Typography>
    );
  }

  return <>{emailAddress}</>;
}
